export class User {
  avatar: string;
  name: string;
  email: string;
  data_sources: string[];
  role: string;
  blocked: boolean;
}
